import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import GoodsGroupList from './GoodsGroupList';
import GoodsGroupDetail from './GoodsGroupDetail';

@inject(({ commonStore, goodsGroupStore }) => ({
  commonStore: commonStore,

  setCommonStoreInfo: goodsGroupStore.setCommonStoreInfo,
  onClear: goodsGroupStore.onClear,
  viewMode: goodsGroupStore.viewMode,
  onViewMode: goodsGroupStore.onViewMode,
  disGoodsGroupList: goodsGroupStore.disGoodsGroupList,
}))
@observer
class GoodsGroupContainer extends Component {

  UNSAFE_componentWillMount() {
    this.props.setCommonStoreInfo(this.props.commonStore);
    this.props.onClear();
    this.props.disGoodsGroupList(1);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.viewMode !== this.props.viewMode) {
      if (nextProps.viewMode === 'list') {
        this.props.history.push('/goodsGroupManage');
      } else {
        this.props.history.push('/goodsGroupManage/'+nextProps.viewMode);
      }
    }
    if(nextProps.location.pathname !== this.props.location.pathname) {
      // 뒤로가기 버튼을 눌러서 주소가 바뀌었을 때 viewMode 상태가 detail 이면 list로 변경해준다.
      if (nextProps.location.pathname.lastIndexOf("/") === 0) {
        if (nextProps.viewMode !== 'list') {
          this.props.onViewMode("list");
        }
      } else {
        let pageMode = nextProps.location.pathname.substring(nextProps.location.pathname.lastIndexOf("/")+1);
        // console.log("pageMode", pageMode);
        if (nextProps.viewMode !== pageMode) {
          this.props.onViewMode(pageMode);
        }
      }
    }
  }

  render() {
    const { viewMode } = this.props;
    return (
      viewMode === 'list'
      ? <GoodsGroupList /> 
      : <GoodsGroupDetail />
    );
  }

}

export default withRouter(GoodsGroupContainer);
